import types from "../types"

export default {
  start: function processingStart(type, task, model, id) {
    return {
      type: types.processingStart,
      processType: type,
      task,
      model,
      id,
    }
  },
  complete: function processingComplete(type, task, model, id) {
    return {
      type: types.processingComplete,
      processType: type,
      task,
      model,
      id,
    }
  },
}
